"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-calendar/lib/date/DateConstants.js
// module id = 421
// module chunks = 0